import Root from './Root.svelte';
import { installGlobalErrorHandler } from './js/errorReporter.js';

// Install BEFORE constructing the Svelte root so any error thrown during
// the initial render / mount is captured too.
installGlobalErrorHandler();

const root = new Root({
	target: document.body,
	props: {
		
	}
});

export default root;